import React, { Component } from "react";
import { BrowserRouter, NavLink, Redirect, Switch } from "react-router-dom";
import ShippingComponent from "./Intransit/IntransitComponent";
import DeliveryOrder from "./Intransit/DeliverOrder/DeliveryOrder";
import DeliverySuccess from "./Intransit/DeliverySuccess/DeliverySuccess";
import Sodexo from "./Intransit/Payment/Sodexo";
import PaymentCashCard from "./Intransit/Payment/PaymentCashCard";
import AssignedComponent from "./Assigned/AssignedComponent";
import CompletedComponent from "./Completed/CompletedComponent";
import ViewDetails from "./Completed/ViewDetails";
import api from "../utility/api/api.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  totalItems,
  pickedStatusAction,
  actionOrderDetails,
} from "../actions/index";
import { withRouter } from "react-router";
import { browserHistory } from "react-router";
import Route from "react-router-hooks";
import createHistory from "history/createBrowserHistory";
class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = { currentLocation: window.location.pathname };
    this.fullHeader(window.location.pathname);
    // api.getmasterData();
    const history = createHistory();
    this.unlisten = history.listen((location, action) => {
      switch (this.state.currentLocation) {
        case "/":
          this.props.history.push("/");
          break;
        case "/intransit":
          this.props.history.push("/");
          break;
        case "/completed":
          this.props.history.push("/intransit");
          break;
        case "/deliveryorder":
          this.props.history.push("/intransit");
          break;
        // case "/paymentsodexo":
        //   this.props.history.push("/deliveryorder");
        //   break;
        // case "/paymentcardcash":
        //   this.props.history.push("/paymentsodexo");
        //   break;
        case "/deliverysuccess":
          localStorage.removeItem("orderData");
          this.props.history.push("/intransit");

          break;
        default:
      }
    });
  }

  fullHeader(pathname) {
    if (
      (pathname === "/intransit" && this.props.intransitJobs) ||
      pathname === "/deliveryorder" ||
      pathname === "/deliveredDetails" ||
      pathname === "/deliverysuccess" ||
      pathname === "/paymentcardcash" ||
      pathname === "/paymentsodexo"
    ) {
      if (document.getElementById("header-nav-bar")) {
        document.getElementById("header-nav-bar").classList.remove("d-flex");
        document.getElementById("header-nav-bar").classList.add("d-none");
      }
      if (document.getElementById("header-component")) {
        document.getElementById("header-component").classList.add("d-none");
        document.getElementById("header-nav-bar").classList.add("displayNone");
      }
    } else if (pathname === "/" || pathname === "/completed") {
      if (document.getElementById("header-nav-bar")) {
        document.getElementById("header-nav-bar").classList.add("d-flex");
        document.getElementById("header-nav-bar").classList.remove("d-none");
      }
      if (document.getElementById("header-component")) {
        document.getElementById("header-component").classList.remove("d-none");
      }
    } else {
      document.getElementById("header-component") &&
        document.getElementById("header-component").classList.remove("d-none");
    }
  }
  componentWillMount() {
    if (localStorage.getItem("orderData")) {
      this.props.actionOrderDetails(
        JSON.parse(localStorage.getItem("orderData"))
      );
    }
  }
  componentWillReceiveProps(nextprops) {
    this.fullHeader(this.state.currentLocation);
    // if (
    //   nextprops.order &&
    //   !nextprops.order.orderData.collectable_sodexo &&
    //   window.location.pathname === "/paymentcardcash"
    // ) {
    //   this.setState({ currentLocation: "/paymentsodexo" });
    // }
  }
  onLeaveRoute(e) {
    let pathname = window.location.pathname;
    // if (
    //   this.props.order &&
    //   !this.props.order.orderData.collectable_sodexo &&
    //   window.location.pathname === "/paymentcardcash"
    // ) {
    //   pathname = "/paymentsodexo";
    // }
    this.fullHeader(pathname);
    this.setState({ currentLocation: pathname });
  }
  render() {
    return (
      <main>
        <BrowserRouter>
          <div className="menu">
            <div
              id="header-nav-bar"
              className="menubutton box-shadow position-fixed d-flex w-100 justify-content-around"
            >
              <NavLink exact to="/">
                <button>Assigned</button>
              </NavLink>
              <NavLink exact to="/intransit">
                <button>In-Transit</button>
              </NavLink>
              <NavLink exact to="/completed">
                <button>Completed</button>
              </NavLink>
            </div>

            <Switch>
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/"
                component={() => <AssignedComponent />}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/intransit"
                component={ShippingComponent}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/completed"
                component={CompletedComponent}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/deliveryorder"
                component={DeliveryOrder}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/deliveredDetails"
                component={ViewDetails}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/deliverysuccess"
                component={DeliverySuccess}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/paymentsodexo"
                component={Sodexo}
              />
              <Route
                onLeave={(e) => this.onLeaveRoute(e)}
                onEnter={(e) => this.fullHeader(this.state.currentLocation)}
                exact
                path="/paymentcardcash"
                component={PaymentCashCard}
              />
              {window.location.pathname === "/intransit/cancelorder" ||
              window.location.pathname === "/intransit/returnproducts" ? (
                <Redirect to="/intransit" />
              ) : (
                <Redirect to="/" />
              )}
            </Switch>
          </div>
        </BrowserRouter>
      </main>
    );
  }
}
function mapStateToProps(state) {
  return {
    order: state.orderDetails,
    intransitJobs: state.processingJobs,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { actionOrderDetails: actionOrderDetails },
    dispatch
  );
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainPage)
);



// WEBPACK FOOTER //
// ./src/components/MainPage.js